module.exports = __webpack_public_path__ + "static/corezoid-oslo-open-api-2016-5e2e7d1303271be5d25938c736fc26ec.webp";